import { render, staticRenderFns } from "./m-admission.html?vue&type=template&id=5e64b0a6&scoped=true&external"
import script from "./m-admission.js?vue&type=script&lang=js&external"
export * from "./m-admission.js?vue&type=script&lang=js&external"
import style0 from "./m-admission.scss?vue&type=style&index=0&id=5e64b0a6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64b0a6",
  null
  
)

export default component.exports